import { Box } from '@frontend/components';

import NavItems from './NavItems';

const MobileTabs = () => {
  return (
    <Box
      display={{
        base: 'flex',
        tablet: 'none',
      }}
      bottom="0"
      left="0"
      height={8}
      minHeight={8}
      bg="page.surface"
      width="100%"
      borderTop="1px solid"
      borderColor="separator.divider"
      zIndex="10"
    >
      <NavItems
        isMobile
        iconTextProps={{
          fontSize: '9px',
        }}
      />
    </Box>
  );
};

export default MobileTabs;
